module.exports = __webpack_public_path__ + "img/baby_formula_shortage.6dcaef3d.jpg";